import type { AnyItemInArray } from '@baseball-near-you/common';
import { Button } from '@baseball-near-you/ui';
import { type InternalLink, InternalLinkPaths, LinkType } from '@bb/lib/types';
import type {
  Button as IButton,
  Link as ILink,
  MarketingPage,
  Post,
} from '@bb/sanity.types';
import Link from 'next/link';
import type { ReactNode } from 'react';

export function SanityButton({ button }: { button: IButton }) {
  return (
    <Button
      style={{
        backgroundColor: button.color?.hex,
        color: 'white',
      }}
      className="title mt-4 text-md transition-all hover:scale-[101%] hover:opacity-90 md:mt-0"
    >
      {button.text}
    </Button>
  );
}

export function SanityLinkButton({ button }: { button: IButton }) {
  const LinkWrapper = (props: { children: ReactNode }) => {
    const link = button.link as unknown as AnyItemInArray<ILink> | undefined;

    if (!link) {
      return props.children;
    }

    if (link._type === LinkType.InternalNonMarketingPage) {
      return (
        <Link
          className="title"
          href={InternalLinkPaths[link.internal as InternalLink]}
        >
          {props.children}
        </Link>
      );
    }

    if ((link._type as any) === 'marketingPage') {
      const page = link as any as MarketingPage;
      return (
        <Link className="title w-full" prefetch href={`/${page.slug?.current}`}>
          {props.children}
        </Link>
      );
    }

    if ((link._type as any) === 'post') {
      const blog = link as any as Post;
      return (
        <Link
          className="title w-full"
          prefetch
          href={`/blog/${blog.slug?.current}`}
        >
          {props.children}
        </Link>
      );
    }

    if (link._type === LinkType.External) {
      return (
        <a
          className="title"
          rel="noopener noreferrer"
          target="_blank"
          href={link.external}
        >
          {props.children}
        </a>
      );
    }

    console.log('unknown type', link._type, link);
    return <>{props.children}</>;
  };

  return (
    <LinkWrapper>
      <SanityButton button={button} />
    </LinkWrapper>
  );
}
